import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { ApiResponse, CamDeleteModel } from 'src/app/models/interface/CAM/baseResponseInterfaces';
import { TravelCategory, TravelCategoryRequest } from 'src/app/models/interface/CAM/TravellerInterface';
import { CamService } from 'src/app/services/camService/cam.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { NgIf, NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatButton } from '@angular/material/button';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
@Component({
    selector: 'app-travel-category',
    templateUrl: './travel-category.component.html',
    styleUrls: ['./travel-category.component.scss'],
    imports: [ReactiveFormsModule, NgIf, MatIcon, MatFormField, MatLabel, MatInput, MatError, MatRadioGroup, MatRadioButton, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, NgClass, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, CamEmptyStateComponent, CdkScrollable, MatDialogContent, MatDialogActions]
})
export class TravelCategoryComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['Travel Category', 'Status', 'Actions'];
  travelCategory: TravelCategory[] = []
  Addnew: boolean = false;
  travelCatForm!: FormGroup;
  saUserId!: string;
  isLoading = true;
  @ViewChild('selectionWarning') selectionWarning!: TemplateRef<any>;
  currentItem: any;
  openingByPolicyConfiguration: any = {};
  private destroy$ = new Subject<void>();
  content:any;
  dictionaryContent:any;
  constructor(private _CamService: CamService, private fb: FormBuilder, private crypto: CryptoService, private dialog: MatDialog, private _ToastrApiService: ToastrApiService, private _CommonService: CommonService, private _CompanyManagementService: CompanyManagementService, private contentService:CompanyManagementContentService,private readonly dictionContentService:DisctionaryContent) {
    this.travelCatForm = this.fb.group({
      flag: ['ADD'],
      travelCategoryID: [null],
      sauserid: [this.crypto.getValueFromKey('USERID') as string],
      travelCategoryName: ['', [Validators.required, Validators.maxLength(100), Validators.minLength(2)]],
      travelCategoryCode: ['', [Validators.required, Validators.maxLength(30)]],
      travelCategoryType: ['BTC', [Validators.required]],
      status: [true, [Validators.required]],
      applyTravelPolicy: [true, [Validators.required]]
    })
  }

  ngOnInit(): void {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    });
    this.dictionContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.dictionaryContent = res;
    })
    this.getTravelCategoryList()
    this.saUserId = this.crypto.getValueFromKey('USERID') as string;
    this._CommonService.travelCategoryAddTrigger.subscribe(($: any) => {
      this.openingByPolicyConfiguration = $;
      if (this.openingByPolicyConfiguration?.add) {
        this.addNewTravelCat({ travelCategoryType: $.TravelPurpose });
      }
    })
  }

  handleEvent(event: string) {
    if (event.includes('travel-category')) {
      this.Addnew = true;
    }
  }

  addNewTravelCat(values?: any) {
    ;
    this.Addnew = true
    this.travelCatForm.reset({
      flag: 'ADD',
      travelCategoryID: null,
      sauserid: this.saUserId,
      travelCategoryName: '', // Set empty string explicitly
      travelCategoryCode: '', // Set empty string explicitly
      travelCategoryType: values?.travelCategoryType ?? 'BTC',
      status: true,
      applyTravelPolicy: true
    });

    this._CompanyManagementService.company_management_travelCategory('Add link','Add',this.travelCategory.length)//GTM use
  }

  getTravelCategoryList() {
    this._CamService.getTravelCategory().then((res: ApiResponse<TravelCategory[]>) => {

      // 🔥 Handle null API response
      // if (!res || res === null || !res.data || res.data === null) {
      //   this._ToastrApiService.show('error', 'No content available');
      //   return;
      // }

      if (res.status == "Success") {
        this.travelCategory = res.data

      }
    }).catch((e) => {
      this.travelCategory = [];
       const message =
          e?.error?.message ||
          e?.message ||
          'Something went wrong. Please try again.';
      this._CompanyManagementService.view_error_message(message,e?.code);
      console.error(e);

    }).finally(() => {
      this.isLoading = false
    })
  }
  onCancel() {
    this._CommonService.travelCategoryAddTrigger.next({ add: false, isSaved: false, isCancel: true });
    this.Addnew = false
    this.travelCatForm.reset({
      flag: 'ADD',
      travelCategoryID: null,
      sauserid: this.saUserId,
      travelCategoryName: '',
      travelCategoryCode: '',
      travelCategoryType: 'BTC',
      status: true,
      applyTravelPolicy: true
    });

    this._CompanyManagementService.company_management_travelCategory('Cancel button','Cancel',this.travelCategory.length)//GTM use
    
  }

  onSave() {
    this._CompanyManagementService.company_management_travelCategory('Save button','Save',this.travelCategory.length)//GTM use

    if (this.travelCatForm.value.invalid) {
      return
    }

    const requestData: TravelCategoryRequest = {
      flag: this.travelCatForm.value.flag,
      travelCategoryID: this.travelCatForm.value.travelCategoryID,
      sauserid: this.travelCatForm.value.sauserid,
      travelCategoryName: this.travelCatForm.value.travelCategoryName,
      travelCategoryCode: this.travelCatForm.value.travelCategoryCode,
      travelCategoryType: this.travelCatForm.value.travelCategoryType,
      status: this.travelCatForm.value.status,
      applyTravelPolicy: this.travelCatForm.value.applyTravelPolicy,
    }

    this._CamService.insertUpdateTravelCategoryV1(requestData).then((res) => {

      if (!res) {
        this._ToastrApiService.show('error', 'No response received from server.');
        return;
      }

      // Handle API response
      switch (res.status) {
        case 'Created':
          this._ToastrApiService.show('success', res.message || 'Travel category created successfully.');
          this._CompanyManagementService.save_success('Travel category', 'Success')//GTM use
          break;

        case 'Success':
          this._ToastrApiService.show('success', res.message || this.dictionaryContent?.['b2b.inserttravelcategory.200success'] || 'Travel category updated successfully.');
          this._CompanyManagementService.save_success('Travel category', 'Success')//GTM use

          break;

        case 'Conflict':
          this._ToastrApiService.show('warning', res.message || 'Duplicate entry detected.');
          break;

        default:
          this._ToastrApiService.show('error', res.message || 'Unexpected response from server.');
          console.warn('Unhandled status:', res);
          break;
      }


      this.getTravelCategoryList();
      if (this.openingByPolicyConfiguration?.add) {
        sessionStorage.setItem("policyTravelCategory", JSON.stringify(this.travelCatForm.value));
      }
      this.Addnew = false
      this.travelCatForm.reset({
        flag: 'ADD',
        travelCategoryID: null,
        sauserid: this.saUserId,
        travelCategoryName: '',
        travelCategoryCode: '',
        status: true,
        travelCategoryType: 'BTC',
        applyTravelPolicy: true
      })

      this._CommonService.formResetTrigger();
      this._CommonService.travelCategoryAddTrigger.next({ add: true, isSaved: true, });

    }).catch((error) => {
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while saving the travel category. Please try again later.';
        this._CompanyManagementService.view_error_message(errorMessage,error?.code);
      this._ToastrApiService.show('error', errorMessage);
    })
  }

  onEdit(item: TravelCategory) {
    this._CompanyManagementService.company_management_travelCategory('Edit button','Edit',this.travelCategory.length)//GTM use
    this.Addnew = true;
    this.travelCatForm.patchValue({
      flag: 'UPDATE',
      travelCategoryID: item.travelCategoryId,
      sauserid: this.saUserId,
      travelCategoryName: item.travelCategory,
      travelCategoryCode: item.travelCategoryCode,
      travelCategoryType: item.travelCategoryType,
      status: item.status,
      applyTravelPolicy: item.isApplyPolicy
    })
  }

  onRemove(item: TravelCategory) {
    this._CompanyManagementService.company_management_travelCategory('Remove button','Remove',this.travelCategory.length)//GTM use
    this.currentItem = item;
    const dialogRef = this.dialog.open(this.selectionWarning, {
      data: item, // Pass the item data
    });
  }

  confirmDelete(item: TravelCategory) {
    const request: CamDeleteModel = {
      id: item.travelCategoryId,
      type: 'CATEGORY'
    }

    this._CamService.DeleteCAMitemBytype(request).then((res) => {
      if (res.status == "Success") {
        this._ToastrApiService.show('success', res.message);
        this.currentItem = undefined;
        this.getTravelCategoryList()
        this._CompanyManagementService.travel_remove_Successfully('Remove','Success')//GTM use
      }
      if (res.status == 'Failed') {
        this._ToastrApiService.show('error', res.message)
      }
    }).catch((error) => {
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while deleting the travel category. Please try again later.';
        this._CompanyManagementService.view_error_message(errorMessage,error?.code);
      this._ToastrApiService.show('error', errorMessage);
    })
  }

  CloseDialog(result: boolean) {
    if (result) {
      this.confirmDelete(this.currentItem);
      this._CompanyManagementService.travelCategory_remove('Proceed','Are you sure you want to remove this Travel category?')//GTM use
    }
    if(!result){
      this._CompanyManagementService.travelCategory_remove('Cancel','Are you sure you want to remove this Travel category?')//GTM use

    }

    this.dialog.closeAll(); // Closes the dialog
  }

  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  onPasteBlocked(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent the paste action
  }

  blockInvalidCharacters1(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', ':', '$', '|', '[', ']', '~', '--', '@', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}', '&'];

    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }
 ngOnDestroy(){
  this.destroy$.next();
  this.destroy$.complete();
 }

}
